import React from 'react';
import { useInvestmentAmount as useInvestmentAmountByCountry } from '../../hooks/useInvestmentAmountByCountry';
import { CHART_COMPONENTS } from '../../../../types';
import { PieChart } from '../../../../components/Charts/Piechart/PieChart';
import { IMetricsDataModel } from '../../../../data-models/metrics.data-model';
import { IPortfolioChartProps } from './ChartComponent';
import { allChartItems } from './ChartsSection';

export const InvestmentAmountByCountryChart: React.FC<IPortfolioChartProps<IMetricsDataModel>> = (props) => {
  const { data, total } = useInvestmentAmountByCountry(props.filteredMetrics);

  return (
    <PieChart
      data={data}
      title={
        allChartItems.get(CHART_COMPONENTS.INVESTMENT_AMOUNT_BY_COUNTRY)?.value ?? 'Investment by Country'
      }
      id={CHART_COMPONENTS.INVESTMENT_AMOUNT_BY_COUNTRY}
      total={total}
      isFullScreen={props.isFullScreen}
      onOpenFullScreen={props.onOpenFullScreen}
    />
  );
};
